const isMobile = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 650px)').matches;
export default isMobile;